import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import SkeletonTable from "@/components/SkeletonTable";
import { useSearchParams } from "react-router-dom";

const getListDataPendaftaran = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string
) => {
  const response = await api.get(
    `/data-prestasi/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}`,
    {
      withCredentials: true,
    }
  );
  return response.data?.data;
};

export default function DataPrestasiPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataPrestasi",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string
      ),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
      />
    </div>
  );
}
